import { ApolloLinkScalar } from "@config/apollo/apollo-link.type";
import { WKT } from "ol/format";
import { Point } from "ol/geom";
import { ProjectionConfig } from "@config/openlayers/projection.config";

export const PointScalar: () => ApolloLinkScalar<Point> = () => {
    const wkt = new WKT();
    return {
        parseValue: (value: unknown) => {
            try {
                if (typeof value !== "string") throw new Error("Can't parse a non string value");
                const geometry = wkt.readGeometry(value, { dataProjection: ProjectionConfig.backendFormat, featureProjection: ProjectionConfig.displayFormat });
                if (!(geometry instanceof Point)) return null;
                return geometry;
            } catch (err) {
                console.error("Error parsing point scalar", err);
                return null;
            }
        },
        serialize: (value: unknown) => {
            if (!(value instanceof Point)) {
                const error = new Error("Can't serialize a geometry that is not a point");
                console.error(error);
                throw error;
            }
            return wkt.writeGeometry(value, { dataProjection: ProjectionConfig.backendFormat, featureProjection: ProjectionConfig.displayFormat });
        },
    };
};
